(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-audiences"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hh-audience-compact')) {
 customElements.define('hh-audience-compact', class extends HTMLElement {
  connectedCallback() {
   if(this.abort) return;
   this.abort=new AbortController(); const signal=this.abort.signal;
   this.prev=this.querySelector('[data-aud-prev]'); this.next=this.querySelector('[data-aud-next]');
   const shift=direction=>{const track=this.querySelector('.cs-panel:not([hidden]) .cs-products');const card=track?.querySelector('.cs-product');if(!card)return;const step=card.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).columnGap)||0);const count=Math.max(1,Math.round(track.clientWidth/step));track.scrollBy({left:direction*step*count,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
   this.prev?.addEventListener('click',()=>shift(-1),{signal});this.next?.addEventListener('click',()=>shift(1),{signal});
   this.querySelectorAll('.cs-products').forEach(t=>t.addEventListener('scroll',()=>this.update(),{signal,passive:true}));
   this.observer=new MutationObserver(()=>this.update());this.querySelectorAll('.cs-panel').forEach(p=>this.observer.observe(p,{attributes:true,attributeFilter:['hidden']}));
   if(typeof ResizeObserver!=='undefined'){this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this);}
   this.update();
  }
  update(){const t=this.querySelector('.cs-panel:not([hidden]) .cs-products');if(!t)return;if(this.prev)this.prev.disabled=t.scrollLeft<=2;if(this.next)this.next.disabled=t.scrollLeft+t.clientWidth>=t.scrollWidth-2;}
  disconnectedCallback(){this.abort?.abort();this.abort=null;this.observer?.disconnect();this.resize?.disconnect();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hombys-video-guides"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hombys-video-switch')) {
  customElements.define('hombys-video-switch', class extends HTMLElement {
    connectedCallback() {
      if (this.boundClick) return;
      this.boundClick = (event) => {
        const button = event.target.closest('[data-hvg-select]');
        if (!button || !this.contains(button)) return;
        const target = Array.from(this.querySelectorAll('template[data-hvg-template]')).find(item => item.dataset.hvgTemplate === button.dataset.hvgSelect);
        const main = this.querySelector('[data-hvg-main]');
        if (!target || !main) return;
        main.querySelectorAll('video').forEach(video => video.pause());
        main.replaceChildren(target.content.cloneNode(true));
        const heading = this.querySelector('[data-hvg-heading]');
        if (heading) heading.textContent = target.dataset.heading;
        this.querySelectorAll('[data-hvg-select]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        const video = main.querySelector('video');
        if (this.alignSidebar) this.alignSidebar();
        if (video) { const playback = video.play(); if (playback) playback.catch(() => {}); }
        if (window.matchMedia('(max-width: 749px)').matches) {
          main.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
        }
      };
      this.addEventListener('click', this.boundClick);
      this.alignSidebar = () => {
        const main = this.querySelector('[data-hvg-main]');
        const sidebar = this.querySelector('.hvg-sidebar');
        if (!main || !sidebar) return;
        if (window.matchMedia('(min-width: 750px)').matches) {
          sidebar.style.height = `${Math.ceil(main.getBoundingClientRect().height)}px`;
        } else {
          sidebar.style.removeProperty('height');
        }
      };
      if (typeof ResizeObserver !== 'undefined') {
        this.sidebarObserver = new ResizeObserver(this.alignSidebar);
        const main = this.querySelector('[data-hvg-main]');
        if (main) this.sidebarObserver.observe(main);
      }
      window.addEventListener('resize', this.alignSidebar);
      this.alignSidebar();
      if (this.dataset.homeMode !== 'true') {
        const selectedVideo = new URL(window.location.href).searchParams.get('video');
        if (selectedVideo) {
          const target = Array.from(this.querySelectorAll('[data-hvg-select]')).find(button => button.dataset.hvgSelect === selectedVideo);
          if (target) target.click();
        }
      }
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.boundClick);
      this.boundClick = null;
      if (this.sidebarObserver) this.sidebarObserver.disconnect();
      if (this.alignSidebar) window.removeEventListener('resize', this.alignSidebar);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
